var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-tips"},[_vm._v("温馨提示：出签前请勿提前预定机票酒店！由于近期领馆政策变动较频繁，预计出签时间仅为往常经验参考，实际出签时间可能延迟，请以领事馆或签证中心结果为准。")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1c1760","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order-detail/order-tips.vue
// module id = null
// module chunks = 